module.exports = __webpack_public_path__ + "img/camera.c7410690.svg";